module.exports = __webpack_public_path__ + "static/media/the-content-revision-cycle.9a20ef26.jpg";